import SmartImage from 'Components/Common/SmartImage';
import { useElementWidth } from 'hooks/useElementWidth';
import React, { useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { SocialPost } from 'types/campaign/collaborations';
import userDummyImage from "../../assets/images/users/user-dummy-img.jpg"
import { AppDispatch } from 'store';
import { useDispatch } from 'react-redux';
import { showSocialPostModal, toggleSocialAccountView } from 'slices/ui/reducer';
import InstagramCaption from 'Components/Common/InstagramCaption';
import { formatNumber, getTrimmedText } from 'utils/helpers';
import ReelsIcon from 'assets/icons/ReelsIcon';
import IGStoryIcon from 'assets/icons/mono/IGStoryIcon';
import IGPostIcon from 'assets/icons/mono/IGPostIcon';
import MediaLikesIcon from 'assets/icons/mono/MediaLikesIcon';
import MediaViewsIcon from 'assets/icons/mono/MediaViewsIcon';
import MediaCommentsIcon from 'assets/icons/mono/MediaCommentsIcon';
import { CampaignPost } from 'types/campaign/posts';

const ContentMasonry: React.FC<{ posts: CampaignPost[], isLoading: boolean }> = ({ posts, isLoading }) => {

    const wrapperRef = useRef<HTMLDivElement>(null);
    const rowWidth = useElementWidth(wrapperRef);
    const dispatch: AppDispatch = useDispatch();

    return (
        <div ref={wrapperRef}>
            <ResponsiveMasonry
                columnsCountBreakPoints={{
                    350: 1,
                    750: 2,
                    900: 3,
                    1200: 4,
                    1500: Math.floor(rowWidth / 230) || 5
                }}
                gutterBreakPoints={{
                    350: '24px',
                } as unknown as { [breakpoint: number]: number }}
            >
                <Masonry>
                    {posts.map((campaignPost, i) => (
                        <div key={i} className='masonry-item' id={`masonry-item-${i}`}>
                            <div className="cursor-pointer position-relative masonry-media" onClick={() => {
                                if (campaignPost.social_post.social_account) {
                                    dispatch(showSocialPostModal({ postId: campaignPost.social_post.uuid, socialAccount: campaignPost.social_post.social_account }))
                                }
                            }}>
                                <SmartImage key={i} src={campaignPost.social_post.thumbnail_url} alt={campaignPost.social_post.posted_on} wrapperClass='explore-item' className='explore-thumb' />
                                <div className="masonry-overlay flex-column justify-content-between align-items-start p-2">
                                    <div>
                                        {
                                            campaignPost.social_post?.ig?.caption &&
                                            <div className="post-card-caption" style={{ marginTop: '32px', width: '100%' }}>
                                                <InstagramCaption text={getTrimmedText(campaignPost.social_post?.ig?.caption)} />
                                            </div>
                                        }
                                    </div>
                                    <div className="masonry-stats w-100 d-flex align-items-center justify-content-center">
                                        <span className='d-flex align-items-center gap-1'><MediaViewsIcon /> {formatNumber(campaignPost.social_post.views_count ?? 0)}</span>
                                        <span className='d-flex align-items-center gap-1'><MediaLikesIcon /> {formatNumber(campaignPost.social_post.like_count ?? 0)}</span>
                                        <span className='d-flex align-items-center gap-1'><MediaCommentsIcon /> {formatNumber(campaignPost.social_post.comments_count ?? 0)}</span>
                                    </div>
                                </div>
                                <span className="media-type-icon" style={{ left: '8px', top: '8px' }}>
                                    {
                                        campaignPost.social_post.type === 'REELS' &&
                                        <ReelsIcon color="#ffffff" />
                                    }
                                    {
                                        campaignPost.social_post.type === 'STORY' &&
                                        <IGStoryIcon />
                                    }
                                    {
                                        campaignPost.social_post.type === 'VIDEO' &&
                                        <i className="ri-youtube-fill" style={{ fontSize: '24px', color: '#ffffff' }}></i>
                                    }
                                    {
                                        !["REELS", "STORY", "VIDEO"].includes(campaignPost.social_post.type) &&
                                        <IGPostIcon />
                                    }
                                </span>

                            </div>
                            {
                                campaignPost.social_post.social_account &&
                                <div
                                    className="d-flex align-items-center gap-2 mt-2 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (campaignPost.social_post.social_account?.uuid) {
                                            dispatch(toggleSocialAccountView({
                                                socialAccountId: campaignPost.social_post.social_account.uuid,
                                                influencerId: campaignPost.influencer?.uuid,
                                            }));
                                        }
                                    }}
                                >
                                    {campaignPost.social_post.social_account?.profile_picture_url ? (
                                        <img src={campaignPost.social_post.social_account?.profile_picture_url} className="rounded-circle square-30" alt="" />
                                    ) : (
                                        <img src={userDummyImage} className="rounded-circle square-30" alt="" />
                                    )}
                                    <div className="d-flex flex-column gap-0">
                                        <span className='content-masonry-creator-name' >{campaignPost.social_post.social_account?.name ?? `@${campaignPost.social_post.social_account?.handle}`}</span>
                                        {
                                            campaignPost.social_post?.social_account?.name &&
                                            <span className='content-masonry-creator-handle' >{`@${campaignPost.social_post.social_account?.handle}`}</span>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    ))}
                    {
                        (isLoading) &&
                        Array.from({ length: 10 }).map((_, i) => (
                            <div key={i} className="explore-item w-100">
                                <Skeleton width={`100%`} height={i % 2 === 0 ? 420 : 340} />
                            </div>
                        ))
                    }
                </Masonry>
            </ResponsiveMasonry>
        </div>
    )
}

export default ContentMasonry
